{
  "version": "1.0.0",
  "generatedFrom": "fixtures/reference/earth-3-field-guide.html",
  "baselineDate": "2026-08-01",
  "routing": {
    "defaultRoute": "field",
    "routes": [
      {
        "id": "field",
        "hash": "#field",
        "title": "The Field"
      },
      {
        "id": "stellar",
        "hash": "#stellar",
        "title": "Stellar"
      },
      {
        "id": "earth2",
        "hash": "#earth2",
        "title": "Earth 2.0"
      },
      {
        "id": "stars",
        "hash": "#stars",
        "title": "I Eat the Stars"
      },
      {
        "id": "earth3",
        "hash": "#earth3",
        "title": "Earth 3.0"
      },
      {
        "id": "practice",
        "hash": "#practice",
        "title": "The Practice"
      },
      {
        "id": "sources",
        "hash": "#sources",
        "title": "Evidence"
      }
    ],
    "history": "pushState",
    "popstate": true,
    "hashFormat": "#<route>",
    "forbiddenHashFormats": [
      "#/<route>"
    ]
  },
  "globalNavigation": [
    {
      "route": "field",
      "hash": "#field",
      "number": null,
      "label": "Earth 3.0 · Research Field",
      "brand": true
    },
    {
      "route": "stellar",
      "hash": "#stellar",
      "number": "01",
      "label": "Stellar"
    },
    {
      "route": "earth2",
      "hash": "#earth2",
      "number": "02",
      "label": "Earth 2.0"
    },
    {
      "route": "stars",
      "hash": "#stars",
      "number": "03",
      "label": "I Eat the Stars"
    },
    {
      "route": "earth3",
      "hash": "#earth3",
      "number": "04",
      "label": "Earth 3.0"
    },
    {
      "route": "practice",
      "hash": "#practice",
      "number": "05",
      "label": "Practice"
    },
    {
      "route": "sources",
      "hash": "#sources",
      "number": "06",
      "label": "Evidence"
    }
  ],
  "rails": {
    "field": {
      "entries": [
        {
          "label": "Orientation",
          "anchor": "field-section-1",
          "runtime": true
        },
        {
          "label": "Research verdict",
          "anchor": "field-section-2",
          "runtime": true
        },
        {
          "label": "Four fields",
          "anchor": "field-section-3",
          "runtime": true
        }
      ]
    },
    "stellar": {
      "entries": [
        {
          "label": "Proposition",
          "anchor": "stellar-section-1",
          "runtime": true
        },
        {
          "label": "Lexicon",
          "anchor": "stellar-section-2",
          "runtime": true
        },
        {
          "label": "Recognition",
          "anchor": "stellar-section-3",
          "runtime": true
        },
        {
          "label": "Gift & limit",
          "anchor": "stellar-section-4",
          "runtime": true
        }
      ]
    },
    "earth2": {
      "entries": [
        {
          "label": "Declaration",
          "anchor": "earth2-section-1",
          "runtime": true
        },
        {
          "label": "Mandate",
          "anchor": "earth2-section-2",
          "runtime": true
        },
        {
          "label": "The room",
          "anchor": "earth2-section-3",
          "runtime": true
        },
        {
          "label": "Case method",
          "anchor": "earth2-section-4",
          "runtime": true
        },
        {
          "label": "Threshold",
          "anchor": "earth2-section-5",
          "runtime": true
        },
        {
          "label": "Assessment",
          "anchor": "earth2-section-6",
          "runtime": true
        },
        {
          "label": "Refusals",
          "anchor": "earth2-section-7",
          "runtime": true
        }
      ]
    },
    "stars": {
      "entries": [
        {
          "label": "Orientation",
          "anchor": "stars-section-1",
          "runtime": true
        },
        {
          "label": "Contrast",
          "anchor": "stars-section-2",
          "runtime": true
        },
        {
          "label": "Shared ground",
          "anchor": "stars-section-3",
          "runtime": true
        },
        {
          "label": "Correction",
          "anchor": "stars-section-4",
          "runtime": true
        },
        {
          "label": "Reality check",
          "anchor": "stars-section-5",
          "runtime": true
        }
      ]
    },
    "earth3": {
      "entries": [
        {
          "label": "Premise",
          "anchor": "earth3-premise",
          "runtime": false
        },
        {
          "label": "Architecture",
          "anchor": "earth3-architecture",
          "runtime": false
        },
        {
          "label": "Commons",
          "anchor": "earth3-commons",
          "runtime": false
        },
        {
          "label": "Decisions",
          "anchor": "earth3-decisions",
          "runtime": false
        },
        {
          "label": "Proof",
          "anchor": "earth3-proof",
          "runtime": false
        }
      ]
    },
    "practice": {
      "entries": [
        {
          "label": "Position",
          "anchor": "practice-section-1",
          "runtime": true
        },
        {
          "label": "Offers",
          "anchor": "practice-section-2",
          "runtime": true
        },
        {
          "label": "Fit",
          "anchor": "practice-section-3",
          "runtime": true
        },
        {
          "label": "Narrative",
          "anchor": "practice-section-4",
          "runtime": true
        },
        {
          "label": "90 days",
          "anchor": "practice-section-5",
          "runtime": true
        },
        {
          "label": "Message",
          "anchor": "practice-section-6",
          "runtime": true
        },
        {
          "label": "Naming",
          "anchor": "practice-section-7",
          "runtime": true
        }
      ]
    },
    "sources": {
      "entries": [
        {
          "label": "Evidence grammar",
          "anchor": "sources-section-1",
          "runtime": true
        },
        {
          "label": "Core texts",
          "anchor": "sources-section-2",
          "runtime": true
        },
        {
          "label": "Planetary condition",
          "anchor": "sources-section-3",
          "runtime": true
        },
        {
          "label": "Transition lineages",
          "anchor": "sources-section-4",
          "runtime": true
        },
        {
          "label": "Rights & legitimacy",
          "anchor": "sources-section-5",
          "runtime": true
        },
        {
          "label": "Open questions",
          "anchor": "sources-section-6",
          "runtime": true
        }
      ]
    }
  },
  "sections": {
    "field": {
      "ids": [
        "field-title"
      ],
      "sectionBlocks": []
    },
    "stellar": {
      "ids": [
        "stellar-title"
      ],
      "sectionBlocks": [
        {
          "id": null,
          "label": "The proposition"
        },
        {
          "id": null,
          "label": "Working lexicon"
        },
        {
          "id": null,
          "label": "The recognition"
        },
        {
          "id": null,
          "label": "What it gives / misses"
        }
      ]
    },
    "earth2": {
      "ids": [
        "earth2-title"
      ],
      "sectionBlocks": [
        {
          "id": null,
          "label": null
        },
        {
          "id": null,
          "label": "The causal claim"
        },
        {
          "id": null,
          "label": "The original room"
        },
        {
          "id": null,
          "label": "The case method"
        },
        {
          "id": null,
          "label": "The Threshold"
        },
        {
          "id": null,
          "label": "Assessment"
        },
        {
          "id": null,
          "label": "The refusals"
        }
      ]
    },
    "stars": {
      "ids": [
        "stars-title"
      ],
      "sectionBlocks": [
        {
          "id": null,
          "label": "What the book is doing"
        },
        {
          "id": null,
          "label": "Why it felt opposite"
        },
        {
          "id": null,
          "label": "The hidden agreement"
        },
        {
          "id": null,
          "label": "The correction"
        },
        {
          "id": null,
          "label": "Reality check"
        }
      ]
    },
    "earth3": {
      "ids": [
        "earth3-premise",
        "earth3-title",
        "model-title",
        "model-description",
        "model-summary",
        "earth3-definition",
        "earth3-integration",
        "earth3-architecture",
        "earth3-commons",
        "earth3-spine",
        "earth3-principles",
        "earth3-decisions",
        "earth3-stress-test",
        "earth3-proof"
      ],
      "sectionBlocks": [
        {
          "id": "earth3-definition",
          "label": null
        },
        {
          "id": "earth3-integration",
          "label": "The higher integration"
        },
        {
          "id": "earth3-architecture",
          "label": "The temporal portfolio"
        },
        {
          "id": "earth3-commons",
          "label": "The operating unit"
        },
        {
          "id": "earth3-spine",
          "label": "The operating spine"
        },
        {
          "id": "earth3-principles",
          "label": "Constitutional principles"
        },
        {
          "id": "earth3-decisions",
          "label": "Readiness gates"
        },
        {
          "id": "earth3-stress-test",
          "label": "Stress test"
        },
        {
          "id": "earth3-proof",
          "label": "Proof standard"
        }
      ]
    },
    "practice": {
      "ids": [
        "practice-title"
      ],
      "sectionBlocks": [
        {
          "id": null,
          "label": null
        },
        {
          "id": null,
          "label": "The offer architecture"
        },
        {
          "id": null,
          "label": "Engagement filter"
        },
        {
          "id": null,
          "label": "The narrative"
        },
        {
          "id": null,
          "label": "90-day landing path"
        },
        {
          "id": null,
          "label": "Message house"
        },
        {
          "id": null,
          "label": "Naming recommendation"
        }
      ]
    },
    "sources": {
      "ids": [
        "sources-title",
        "source-a1",
        "source-a2",
        "source-s01",
        "source-s02",
        "source-s03",
        "source-s04",
        "source-s05",
        "source-s06",
        "source-s07",
        "source-s08",
        "source-s09",
        "source-s11",
        "source-s12"
      ],
      "sectionBlocks": [
        {
          "id": null,
          "label": "Evidence grammar"
        },
        {
          "id": "source-a1",
          "label": "Core texts"
        },
        {
          "id": "source-s06",
          "label": "Planetary condition"
        },
        {
          "id": "source-s11",
          "label": "Transition lineages"
        },
        {
          "id": null,
          "label": "Rights &amp; legitimacy"
        },
        {
          "id": null,
          "label": "Still unresolved"
        }
      ]
    }
  },
  "fieldRuntimeAnchors": [
    {
      "label": "Orientation",
      "anchor": "field-section-1",
      "selector": ".hero"
    },
    {
      "label": "Research verdict",
      "anchor": "field-section-2",
      "selector": ".verdict-card"
    },
    {
      "label": "Four fields",
      "anchor": "field-section-3",
      "selector": ".four-fields"
    }
  ],
  "externalUrlMultiset": [
    "https://www.rethinkx.com/publications/stellar",
    "https://www.penguin.com.au/books/i-eat-the-stars-9781761620775",
    "https://www.theguardian.com/wellness/2026/jul/29/sarah-wilson-book-interview",
    "https://sarahwilson.substack.com/p/table-of-contents",
    "https://www.stockholmresilience.org/research/planetary-boundaries.html",
    "https://www.ipcc.ch/report/ar6/syr/figures/summary-for-policymakers/figure-spm-6/",
    "https://royalsocietypublishing.org/rstb/article/378/1889/20220402/109358/Navigating-polycrisis-long-run-socio-cultural",
    "https://www.internationalfuturesforum.com/three-horizons",
    "https://berkana.org/our-work/pioneering-a-new-paradigm/",
    "https://drift.eur.nl/en/publications/toolkit/",
    "https://earthcommission.org/safe-and-just-earth-system-boundaries/",
    "https://www.rethinkx.com/publications/stellar",
    "https://stellarworld.com/",
    "https://www.penguin.com.au/books/i-eat-the-stars-9781761620775",
    "https://www.theguardian.com/wellness/2026/jul/29/sarah-wilson-book-interview",
    "https://sarahwilson.substack.com/p/table-of-contents",
    "https://sarahwilson.substack.com/p/global-publication-day-i-eat-the",
    "https://www.realitystudies.co/p/sarah-wilson-i-eat-the-stars-how-to-live-fully-collapse",
    "https://www.stockholmresilience.org/research/planetary-boundaries.html",
    "https://www.ipcc.ch/report/ar6/syr/figures/summary-for-policymakers/figure-spm-6/",
    "https://royalsocietypublishing.org/rstb/article/378/1889/20220402/109358/Navigating-polycrisis-long-run-socio-cultural",
    "https://earthcommission.org/safe-and-just-earth-system-boundaries/",
    "https://ict.ipbes.net/ipbes-ict-guide/data-and-knowledge-management/citations-of-ipbes-assessments/transformative-change-assessment",
    "https://www.undrr.org/gar/gar2025",
    "https://www.internationalfuturesforum.com/three-horizons",
    "https://berkana.org/our-work/pioneering-a-new-paradigm/",
    "https://www.oecd.org/en/topics/sub-issues/open-government-and-citizen-participation/innovative-public-participation.html",
    "https://www.ilo.org/publications/guidelines-just-transition-towards-environmentally-sustainable-economies",
    "https://www.unesco.org/en/futures-literacy",
    "https://www.climate-kic.org/programmes/place-based-transformations/",
    "https://www.ucl.ac.uk/bartlett/public-purpose/policy/mission-oriented-policy-hub",
    "https://www.stockholmresilience.org/research/insights/2016-11-16-insight-3-adaptive-governance.html",
    "https://doughnuteconomics.org/about-doughnut-economics",
    "https://regenesisgroup.com/book",
    "https://drift.eur.nl/en/publications/toolkit/",
    "https://www.oecd.org/en/topics/anticipatory-governance.html",
    "https://www.stockholmresilience.org/publications/publications/2024-10-12-the-planetary-commons-a-new-paradigm-for-safeguarding-earth-regulating-systems-in-the-anthropocene.html",
    "https://www.resalliance.org/panarchy",
    "https://www.wa.gov.au/organisation/department-of-the-premier-and-cabinet/aboriginal-empowerment-strategy-western-australia-2021-2029",
    "https://www.pc.gov.au/inquiries-and-research/indigenous-evaluation/strategy/",
    "https://aiatsis.gov.au/publication/116530",
    "https://www.legislation.gov.uk/anaw/2015/2/contents"
  ],
  "externalUrlUniqueCount": 31,
  "externalUrlInstanceCount": 42,
  "sourceCardsOrdered": [
    {
      "id": "source-a1",
      "labels": [
        "A1 · SUPPLIED ARTIFACT",
        "15 July 2026 · supplied HTML"
      ],
      "title": "Stellar & The Threshold: The Recognition",
      "blurb": "Claude-produced interpretation commissioned before you wrote the Earth 2.0 declaration; used as the initial recognition map and visual contract.",
      "urls": [],
      "linkTexts": []
    },
    {
      "id": "source-a2",
      "labels": [
        "A2 · YOUR MODEL",
        "24 July 2026 · supplied HTML"
      ],
      "title": "Earth 2.0: The Declaration",
      "blurb": "Your authored mission, architecture, Threshold spine, case sequence, scale path, terms and refusals.",
      "urls": [],
      "linkTexts": []
    },
    {
      "id": "source-s01",
      "labels": [
        "S01 · OFFICIAL"
      ],
      "title": "Stellar: A World Beyond Limits",
      "blurb": "RethinkX’s official report page for the technological convergence and organising-system thesis.",
      "urls": [
        "https://www.rethinkx.com/publications/stellar"
      ],
      "linkTexts": [
        "Open RethinkX source ↗"
      ]
    },
    {
      "id": "source-s02",
      "labels": [
        "S02 · OFFICIAL"
      ],
      "title": "Stellar World",
      "blurb": "The public home of the Stellar framework and its sunrise-system framing.",
      "urls": [
        "https://stellarworld.com/"
      ],
      "linkTexts": [
        "Open Stellar World ↗"
      ]
    },
    {
      "id": "source-s03",
      "labels": [
        "S03 · PUBLISHER"
      ],
      "title": "I Eat the Stars",
      "blurb": "Penguin Australia’s synopsis and publication record for Sarah Wilson’s 2026 book.",
      "urls": [
        "https://www.penguin.com.au/books/i-eat-the-stars-9781761620775"
      ],
      "linkTexts": [
        "Open Penguin source ↗"
      ]
    },
    {
      "id": "source-s04",
      "labels": [
        "S04 · INTERVIEW"
      ],
      "title": "Sarah Wilson on living through collapse",
      "blurb": "Guardian interview on interconnected collapse, local collaboration, democracy, nervous-system capacity, joy and uncertainty.",
      "urls": [
        "https://www.theguardian.com/wellness/2026/jul/29/sarah-wilson-book-interview"
      ],
      "linkTexts": [
        "Open Guardian interview ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S05A · AUTHOR"
      ],
      "title": "Official serialisation contents",
      "blurb": "The four-part architecture and chapter sequence, used to contextualise the first hour of the audiobook within the complete arc.",
      "urls": [
        "https://sarahwilson.substack.com/p/table-of-contents"
      ],
      "linkTexts": [
        "Open contents ↗"
      ]
    },
    {
      "id": "source-s05",
      "labels": [
        "S05 · AUTHOR"
      ],
      "title": "Global publication note",
      "blurb": "Wilson’s own framing of the book as homecoming, reckoning and communion after two years of research and writing.",
      "urls": [
        "https://sarahwilson.substack.com/p/global-publication-day-i-eat-the"
      ],
      "linkTexts": [
        "Open author note ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S05B · INTERVIEW"
      ],
      "title": "Reality Studies conversation",
      "blurb": "Extended discussion of polycrisis, planetary boundaries, sensemaking, coordination traps and the book’s personal register.",
      "urls": [
        "https://www.realitystudies.co/p/sarah-wilson-i-eat-the-stars-how-to-live-fully-collapse"
      ],
      "linkTexts": [
        "Open interview ↗"
      ]
    },
    {
      "id": "source-s06",
      "labels": [
        "S06 · RESEARCH CENTRE"
      ],
      "title": "Planetary Boundaries",
      "blurb": "Stockholm Resilience Centre’s framework and 2025 status update.",
      "urls": [
        "https://www.stockholmresilience.org/research/planetary-boundaries.html"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": "source-s07",
      "labels": [
        "S07 · IPCC"
      ],
      "title": "AR6 Synthesis: narrowing pathways",
      "blurb": "IPCC synthesis figure on mitigation and development pathways as warming increases.",
      "urls": [
        "https://www.ipcc.ch/report/ar6/syr/figures/summary-for-policymakers/figure-spm-6/"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": "source-s08",
      "labels": [
        "S08 · PEER REVIEW"
      ],
      "title": "Navigating polycrisis",
      "blurb": "Long-run evidence showing that shocks interact with popular immiseration, elite conflict and state capacity rather than mechanically producing collapse.",
      "urls": [
        "https://royalsocietypublishing.org/rstb/article/378/1889/20220402/109358/Navigating-polycrisis-long-run-socio-cultural"
      ],
      "linkTexts": [
        "Open Royal Society source ↗"
      ]
    },
    {
      "id": "source-s09",
      "labels": [
        "S09 · EARTH COMMISSION"
      ],
      "title": "Safe and Just Earth System Boundaries",
      "blurb": "Framework connecting biophysical stability with justice and human exposure.",
      "urls": [
        "https://earthcommission.org/safe-and-just-earth-system-boundaries/"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S10 · IPBES"
      ],
      "title": "Transformative Change Assessment",
      "blurb": "Assessment framing transformative change as shifts in views, structures and practices, with Indigenous and local knowledge integral.",
      "urls": [
        "https://ict.ipbes.net/ipbes-ict-guide/data-and-knowledge-management/citations-of-ipbes-assessments/transformative-change-assessment"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S10B · UNDRR"
      ],
      "title": "Global Assessment Report 2025",
      "blurb": "UNDRR analysis of systemic risk, resilience and investment choices.",
      "urls": [
        "https://www.undrr.org/gar/gar2025"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": "source-s11",
      "labels": [
        "S11 · FUTURES"
      ],
      "title": "Three Horizons",
      "blurb": "International Futures Forum’s framework for seeing dominant, transition and emerging patterns together.",
      "urls": [
        "https://www.internationalfuturesforum.com/three-horizons"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": "source-s12",
      "labels": [
        "S12 · SYSTEM CHANGE"
      ],
      "title": "Berkana’s Two Loops",
      "blurb": "A lineage for naming, connecting, nourishing and illuminating pioneers while hospicing the old.",
      "urls": [
        "https://berkana.org/our-work/pioneering-a-new-paradigm/"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S13 · OECD"
      ],
      "title": "Innovative public participation",
      "blurb": "Evidence and guidance on representative deliberative processes and institutionalisation.",
      "urls": [
        "https://www.oecd.org/en/topics/sub-issues/open-government-and-citizen-participation/innovative-public-participation.html"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S14 · ILO"
      ],
      "title": "Just Transition Guidelines",
      "blurb": "International labour framework for fairness, decent work and social dialogue through environmental transition.",
      "urls": [
        "https://www.ilo.org/publications/guidelines-just-transition-towards-environmentally-sustainable-economies"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S15 · UNESCO"
      ],
      "title": "Futures Literacy",
      "blurb": "UNESCO capability for using multiple imagined futures to act differently in the present.",
      "urls": [
        "https://www.unesco.org/en/futures-literacy"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S16 · CLIMATE-KIC"
      ],
      "title": "Place-based transformations",
      "blurb": "Portfolio and deep-demonstration practice for complex, systemic climate transition.",
      "urls": [
        "https://www.climate-kic.org/programmes/place-based-transformations/"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S17 · UCL IIPP"
      ],
      "title": "Mission-oriented policy",
      "blurb": "Public-purpose practice for aligning institutions, investment and innovation around missions.",
      "urls": [
        "https://www.ucl.ac.uk/bartlett/public-purpose/policy/mission-oriented-policy-hub"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S18 · STOCKHOLM"
      ],
      "title": "Adaptive governance",
      "blurb": "Principles for learning, polycentric coordination and governing dynamic social-ecological systems.",
      "urls": [
        "https://www.stockholmresilience.org/research/insights/2016-11-16-insight-3-adaptive-governance.html"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S19 · DOUGHNUT ECONOMICS"
      ],
      "title": "Social foundation, ecological ceiling",
      "blurb": "A widely used visual and practice framework for thriving within social and planetary boundaries.",
      "urls": [
        "https://doughnuteconomics.org/about-doughnut-economics"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S20 · REGENESIS"
      ],
      "title": "Regenerative development",
      "blurb": "Place-sourced practice focused on living systems, potential and developmental rather than extractive intervention.",
      "urls": [
        "https://regenesisgroup.com/book"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S25 · DRIFT"
      ],
      "title": "Transition management & the X-curve",
      "blurb": "A practical bridge between build-up and breakdown: emergence and institutionalisation alongside destabilisation and phase-out.",
      "urls": [
        "https://drift.eur.nl/en/publications/toolkit/"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S26 · OECD"
      ],
      "title": "Anticipatory governance",
      "blurb": "Institutional foresight, experimentation and learning so governments can prepare for plausible futures without pretending to predict them.",
      "urls": [
        "https://www.oecd.org/en/topics/anticipatory-governance.html"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S27 · PLANETARY COMMONS"
      ],
      "title": "Polycentric stewardship",
      "blurb": "Cross-scale governance for Earth-regulating systems, correcting both top-down control and isolated localism.",
      "urls": [
        "https://www.stockholmresilience.org/publications/publications/2024-10-12-the-planetary-commons-a-new-paradigm-for-safeguarding-earth-regulating-systems-in-the-anthropocene.html"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S28 · RESILIENCE ALLIANCE"
      ],
      "title": "Adaptive cycles & panarchy",
      "blurb": "Growth, conservation, release and reorganisation across nested scales, useful for graceful phase-out and renewal.",
      "urls": [
        "https://www.resalliance.org/panarchy"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S21 · WESTERN AUSTRALIA"
      ],
      "title": "Aboriginal Empowerment Strategy",
      "blurb": "WA government strategy for Aboriginal-led decision-making, partnership and accountability.",
      "urls": [
        "https://www.wa.gov.au/organisation/department-of-the-premier-and-cabinet/aboriginal-empowerment-strategy-western-australia-2021-2029"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S22 · PRODUCTIVITY COMMISSION"
      ],
      "title": "Indigenous Evaluation Strategy",
      "blurb": "Principles for evaluation centred on Indigenous people, perspectives, priorities and knowledges.",
      "urls": [
        "https://www.pc.gov.au/inquiries-and-research/indigenous-evaluation/strategy/"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S23 · AIATSIS"
      ],
      "title": "Indigenous Data Sovereignty",
      "blurb": "Foundational material on Indigenous governance of data, knowledge and its use.",
      "urls": [
        "https://aiatsis.gov.au/publication/116530"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    },
    {
      "id": null,
      "labels": [
        "S24 · WALES"
      ],
      "title": "Well-being of Future Generations Act",
      "blurb": "A statutory example of long-term public duties, prevention, collaboration and future-generations accountability.",
      "urls": [
        "https://www.legislation.gov.uk/anaw/2015/2/contents"
      ],
      "linkTexts": [
        "Open source ↗"
      ]
    }
  ],
  "sourceCardCount": 33,
  "htmlIds": [
    "progress",
    "railToggle",
    "railHeading",
    "sectionNav",
    "content",
    "route-field",
    "field-title",
    "route-stellar",
    "stellar-title",
    "route-earth2",
    "earth2-title",
    "route-stars",
    "stars-title",
    "route-earth3",
    "earth3-premise",
    "earth3-title",
    "model-title",
    "model-description",
    "model-summary",
    "earth3-definition",
    "earth3-integration",
    "earth3-architecture",
    "earth3-commons",
    "earth3-spine",
    "earth3-principles",
    "earth3-decisions",
    "earth3-stress-test",
    "earth3-proof",
    "route-practice",
    "practice-title",
    "route-sources",
    "sources-title",
    "source-a1",
    "source-a2",
    "source-s01",
    "source-s02",
    "source-s03",
    "source-s04",
    "source-s05",
    "source-s06",
    "source-s07",
    "source-s08",
    "source-s09",
    "source-s11",
    "source-s12"
  ],
  "htmlIdCount": 45,
  "htmlIdUniqueCount": 45,
  "chapterBodyHashes": {
    "stellar": {
      "sha256": "63045a611b3a9914e85eafb84da57bccbee7a131a52d3fd0a1558be646a3d53b",
      "matchesBaseline": true,
      "normalizedLength": 3003
    },
    "earth2": {
      "sha256": "e827e574ed75e2b707b91869b6655c8fd1d3f4f9a8ccbae171b65c5c42244c01",
      "matchesBaseline": true,
      "normalizedLength": 3439
    },
    "stars": {
      "sha256": "6ed6bb3efc56c073fc2853f654bbb3a6806ba42ff9d4c2657ef7392eae56ab30",
      "matchesBaseline": true,
      "normalizedLength": 3760
    },
    "earth3": {
      "sha256": "ce47ade4176f6dfa5668cad7af2339ff190567272d0d76915593b635e2c458d8",
      "matchesBaseline": true,
      "normalizedLength": 6394
    },
    "practice": {
      "sha256": "5ce0fb02a18ccd2ea8b61fdc1654c19e598aa9d7fa259cb225b365bb6f6f9927",
      "matchesBaseline": true,
      "normalizedLength": 4378
    },
    "sources": {
      "sha256": "5b6a5c16e92897600f84f7583c617705420840f039c0ed32faa58fe92e663777",
      "matchesBaseline": true,
      "normalizedLength": 7072
    }
  },
  "fieldRouteTextHash": "83e61a33d53b8031b2ed55f7c311320beb596d8e970b7f582b7d0fce0391035c",
  "metadata": {
    "documentTitle": "Earth 3.0 · The Third Way · Nicole Lockwood",
    "metaDescription": "A research-led synthesis of Stellar, Nicole Lockwood's Earth 2.0 model, I Eat the Stars, and the emerging Earth 3.0 transition practice.",
    "skipLinkText": "Skip to content",
    "lang": "en",
    "defaultRoute": "field",
    "canonicalHashes": [
      "#field",
      "#stellar",
      "#earth2",
      "#stars",
      "#earth3",
      "#practice",
      "#sources"
    ],
    "historyApi": "pushState",
    "livingCrossing": {
      "title": "The Living Crossing",
      "description": "A governed system for continuity, transition and regeneration.",
      "summary": "Bound defines the safe-and-just limits. See senses the living system in context. Hold protects what must endure, Cross retires what no longer serves, and Grow cultivates what comes next. Choose brings decisions into a transition commons. Shift coordinates action across scales and Learn closes the feedback loop."
    },
    "railKickerDefault": "Research field",
    "railHeading": "On this page",
    "railMeta": "Living research · synthesis v0.1"
  },
  "accessibilityCopy": {
    "skipLink": "Skip to content",
    "livingCrossingTitle": "The Living Crossing",
    "livingCrossingDescription": "A governed system for continuity, transition and regeneration.",
    "livingCrossingSummary": "Bound defines the safe-and-just limits. See senses the living system in context. Hold protects what must endure, Cross retires what no longer serves, and Grow cultivates what comes next. Choose brings decisions into a transition commons. Shift coordinates action across scales and Learn closes the feedback loop.",
    "operatingSpineAriaLabel": "Earth 3.0 operating spine",
    "pageRailAriaLabel": "On this page"
  },
  "directReaderPhrases": [
    "You have not lost the model.",
    "Stellar did not invent your model.",
    "Your architecture for turning readiness into a durable mandate",
    "This book does not negate your mission.",
    "You read readiness, compose authority",
    "Your authority comes from twenty-five years"
  ],
  "forbiddenThirdPersonPhrases": [
    "Nicole has not lost the model.",
    "gave Nicole recognition language",
    "Nicole composes a protected room",
    "Nicole has spent a career",
    "gives Nicole language",
    "Nicole constructs anticipatory mandate",
    "Nicole heard the book",
    "does not negate Nicole’s mission",
    "Nicole reads readiness",
    "depends on Nicole",
    "Nicole is expected to carry",
    "Nicole’s authority comes from",
    "Nicole knows when a room can move",
    "She connects authority",
    "Her exit condition is"
  ],
  "emDashForbidden": true,
  "livingCrossingNodes": [
    {
      "key": "bound",
      "label": "Bound",
      "text": "Safe-and-just limits"
    },
    {
      "key": "see",
      "label": "See",
      "text": "Sense the living system in context."
    },
    {
      "key": "hold",
      "label": "Hold",
      "text": "Protect what must endure."
    },
    {
      "key": "choose",
      "label": "Choose",
      "text": "Transition commons"
    },
    {
      "key": "grow",
      "label": "Grow",
      "text": "Cultivate what comes next."
    },
    {
      "key": "cross",
      "label": "Cross",
      "text": "Retire what no longer serves."
    },
    {
      "key": "shift",
      "label": "Shift",
      "text": "Coordinate action across scales."
    },
    {
      "key": "learn",
      "label": "Learn",
      "text": "Close the loop. Improve the model."
    }
  ],
  "operatingSpine": [
    {
      "key": "bound",
      "label": "Bound",
      "text": "Define the safe-and-just limits."
    },
    {
      "key": "see",
      "label": "See",
      "text": "Sense the living system in context."
    },
    {
      "key": "choose",
      "label": "Choose",
      "text": "Decide in the transition commons."
    },
    {
      "key": "shift",
      "label": "Shift",
      "text": "Act with coordination and care."
    },
    {
      "key": "learn",
      "label": "Learn",
      "text": "Reflect, adapt and improve."
    }
  ],
  "earth3Opening": {
    "index": "04 · The Third Way",
    "title": "Earth 3.0",
    "tagline": "Govern change before, through and beyond disruption.",
    "conditions": [
      "Built for uncertainty",
      "Governed by safe-and-just limits",
      "Designed to leave capability behind"
    ]
  },
  "assets": [
    "public/assets/botanical-linework.svg",
    "public/assets/living-crossing-field.webp"
  ],
  "iconsRequired": [
    "bound",
    "see",
    "choose",
    "shift",
    "learn",
    "rail-premise",
    "rail-architecture",
    "rail-commons",
    "rail-decisions",
    "rail-proof",
    "nav-menu",
    "nav-close"
  ],
  "sourceElementIds": [
    "source-a1",
    "source-a2",
    "source-s01",
    "source-s02",
    "source-s03",
    "source-s04",
    "source-s05",
    "source-s06",
    "source-s07",
    "source-s08",
    "source-s09",
    "source-s11",
    "source-s12"
  ]
}
